import React from "react";
//
import {
    makeStyles,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: theme.spacing(1),
    },
}));

export default function Confirmation(props) {
    const { open, onClose, title, children, onConfirm, confirmLabel, closeLabel } = props;
    const classes = useStyles();

    const handleOnClick = () => {
        onConfirm().then(() => onClose(true));
    };
    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            PaperProps={{
                className: classes.dialog,
            }}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleOnClick}>
                    {confirmLabel}
                </Button>
                <Button onClick={onClose}>{closeLabel}</Button>
            </DialogActions>
        </Dialog>
    );
}

Confirmation.defaultProps = {
    title: "Confirmation",
    confirmLabel: "OK",
    closeLabel: "CANCEL",
};
